import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { productDetailsImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={FlyoutProductCreationFaqSection.PRODUCT_DETAILS_EULA}
        question="What should I add in my End-User License Agreement (EULA)? Where is it visible?"
      />
    ),
    answer: (
      <div>
        Buyers on AWS must agree to terms and conditions outlined in your
        products EULA before purchasing. You can upload your own license
        document or use AWS’s{' '}
        <strong>Standard Contract for AWS Marketplace</strong>.
      </div>
    ),
  },
]

interface FlyoutProductDetailsEulaFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductDetailsEulaFaqs: React.FC<
  FlyoutProductDetailsEulaFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - End User License Agreement"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={productDetailsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
